export default "__VITE_ASSET__3304011e__"